import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "sonner";
import { publicApi, formatPublicError, honeypotOf } from "../../lib/publicApi";
import { useT } from "../../lib/i18n";

export default function PayLinkPage() {
  const { token } = useParams();
  const { t } = useT();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [amount, setAmount] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    publicApi.get(`/pay/${encodeURIComponent(token)}`).then((r) => { setInfo(r.data); setAmount(r.data.outstanding); })
      .catch((e) => setError(e?.response?.status === 404 ? t("pay.link_invalid") : formatPublicError(e)));
  }, [token]);

  const pay = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await publicApi.post(`/pay/${encodeURIComponent(token)}`, { amount, website: honeypotOf(e) });
      sessionStorage.setItem("last_payment_attempt", data.attempt_id);
      window.location.assign(data.checkout_url);
    } catch (err) { toast.error(formatPublicError(err)); setBusy(false); }
  };

  return (
    <div className="container-x" style={{ maxWidth: 520, margin: "0 auto", padding: "120px 20px 48px" }} data-testid="pay-link-page">
      <h1 style={{ fontSize: 32, fontWeight: 300, marginBottom: 16 }}>{t("pay.title")}</h1>
      {error && <p data-testid="pay-link-error">{error}</p>}
      {info && (
        <form className="enquiry-form" onSubmit={pay}>
          <input type="text" name="website" tabIndex={-1} autoComplete="off" style={{ display: "none" }} />
          <div data-testid="pay-link-invoice">{t("pay.invoice")}: <b className="mono">{info.invoice}</b></div>
          <div>{info.vehicle}</div>
          <div data-testid="pay-link-outstanding">{t("pay.outstanding")}: <b dir="ltr">OMR {Number(info.outstanding).toLocaleString("en-US", { minimumFractionDigits: 3, maximumFractionDigits: 3 })}</b></div>
          <label style={{ display: "grid", gap: 6, fontSize: 13 }}>{t("pay.amount_to_pay")}
            <input type="number" step="0.001" min={info.min_amount} max={info.outstanding} value={amount} onChange={(e) => setAmount(e.target.value)} dir="ltr" data-testid="pay-link-amount" />
          </label>
          <button type="submit" disabled={busy} data-testid="pay-link-submit">{busy ? t("pay.redirecting") : t("pay.pay_now", { amount: `OMR ${amount}` })}</button>
        </form>
      )}
    </div>
  );
}
